import {
  ControlProps,
  isNumberControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";

const DataWithDynamicUnitViewRenderer = ({
  data,
  label,
  uischema,
}: ControlProps) => {
  const { core } = useJsonForms();
  const formData = core?.data ?? {};
  const { unit, unitKey } = uischema.options || {};
  const unitValue = unit
    ? `${unit} ${formData?.[unitKey]}`
    : formData?.[unitKey];
  const value = data ? `${data} ${unitValue}` : "N/A";

  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>{label} :</FormDetailItem>
      <FormDetailValue>{value}</FormDetailValue>
    </FormDetailWrapper>
  );
};

export const dataWithDynamicUnitViewTester: RankedTester = rankWith(
  5,
  isNumberControl,
);

export default withJsonFormsControlProps(DataWithDynamicUnitViewRenderer);
